import axios from "axios";
import store from "../store";
import { showHideLoader } from "../store/Loader/actions";
import { showErrorMsg } from "../utils/Helpers";
import messages from "../assets/locale/messages";

// Generate a unique filename (no spaces or special brackets)
export const generateUniqueFileName = (name) => {
  return `${Date.now()}_${name.replace(/\s/g, "").replace(/(\(|\))/g, "")}`;
};

// S3 folder structure
export const directories = {
  service_categories_logos: "service_categories_logos",
  providers_logos: "providers_logos",
  providers_banners: "providers_banners",
  branch_images: "branch_images",
  providers_CR:"providers_CR",
  providers_contract:"providers_contract"
};

// Upload file using presigned URL flow with axios
export const uploadToS3 = async (file, fileName, directoryName) => {
  store.dispatch(showHideLoader(true));
  const lang = store.getState().locale.lang;

  if (!file) {
    store.dispatch(showHideLoader(false));
    console.error("No file provided for upload.");
    return;
  }

  try {
    // Step 1: Request presigned URL from backend
    const adminData =
      JSON.parse(localStorage.getItem("admin")) ||
      JSON.parse(sessionStorage.getItem("admin"));
    const token = adminData?.auth_token;
    const presignResponse = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/aws/generate_presigned_url`,
      {
        file_name:fileName,
        folder: directoryName,
      },
      {
        headers:{
          Authorization: `Bearer ${token}`,
        }
      }
  );

    const { upload_link, download_link } = presignResponse.data;

    // Step 2: Upload to S3 using axios
    await axios.put(upload_link, file, {
      headers: {
        "Content-Type": file.type,
      },
    });

    //  Step 3: Return final URL to use in your app
    return { link: download_link };
  } catch (error) {
    store.dispatch(showHideLoader(false));

    if (error.message?.includes("Network Error")) {
      showErrorMsg(messages[lang].shared.noInternetConnectionMsg);
    } else {
      showErrorMsg(messages[lang].shared.generalErrMsg);
    }

    throw error;
  }
};

